export default "__VITE_ASSET__CO7Et9pd__"